<div class="input-container">
  <label>{{label}}</label>
  <div class="textarea-wrapper">
    <quill-editor
      [formControl]="control"
      [modules]="editorModules"
      [placeholder]="placeholder!"
      [class.error]="control.touched && !isFocused && control.errors">
    </quill-editor>
    <app-button *ngIf="showActionButton && control?.value?.length === 0" [text]="actionButtonText" [border]="'round'" [style]="'outlined'" [size]="'small'" (clickEvent)="handleActionClick()"></app-button>
  </div>
  <span *ngIf="control?.touched && !isFocused && control?.errors" class="validation-message">
    <ng-container *ngIf="control!.errors!['required']">Das Feld darf nicht leer sein</ng-container>
    <ng-container *ngIf="control!.errors!['minlength']">Die Länge des Textes muss mindestens {{ control!.errors!['minlength'].requiredLength }} Zeichen lang sein</ng-container>
  </span>
</div>